import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { Drawer, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './MagicalNavbar.css';

const MagicalLogo = ({ onClick, className }) => {
  return (
    <div 
      onClick={onClick}
      className={`relative cursor-pointer select-none magical-logo-container ${className}`}
    >
      <h1 className="text-lg md:text-2xl lg:text-3xl font-bold transition-all duration-300 magical-logo-text">
        ShopNexGen
      </h1>
    </div>
  );
};

const Navbar = ({ DrawerList }) => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <div className='h-[10vh] flex items-center px-5 border-b magical-navbar'>
      <div className='flex items-center gap-3'>
        <IconButton 
          onClick={toggleDrawer(true)} 
          color='primary'
          className="transition-all duration-300 hover:scale-110 magical-menu-button"
        >
          <MenuIcon color='primary' />
        </IconButton>

        <MagicalLogo 
          onClick={() => navigate("/")} 
          className=""
        />
      </div>

      <Drawer open={open} onClose={toggleDrawer(false)}>
        <DrawerList toggleDrawer={toggleDrawer} />
      </Drawer>
    </div>
  );
};

export default Navbar;